import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { LANGUAGE_OPTIONS } from '../constants/constants';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private _lang: string = 'en-US';
  private _jsonURL = 'static/assets/i18n/';
  private _languageOptions: any[] = [];

  constructor(
    private http: HttpClient,
    private baseHttp: BaseHttpService
  ) {
      this._languageOptions = LANGUAGE_OPTIONS;
   }

  get lang(): string {
    return this._lang;
  }

  set lang(value: string) {
    try {
      const normalized = value?.trim()?.toLowerCase()?.replace('_', '-');
      const inputPrefix = normalized?.split('-')?.[0];
      
      const validLang = normalized ? LANGUAGE_OPTIONS.find(lang => {
        const langAbbr = lang.language_abbr.toLowerCase();
        const langPrefix = langAbbr.split('-')[0];
        return langAbbr === normalized || 
               langAbbr === inputPrefix || 
               (inputPrefix && inputPrefix.length > 1 && langPrefix === inputPrefix);
      }) : null;
      
      this._lang = validLang?.language_abbr ?? 'en-US';
    } catch {
      this._lang = 'en-US';
    }
  }

  get languageOptions(): any[] {
    return this._languageOptions;
  }

  getLangFile(comp: string, path?: string) {
    let langPath = this._jsonURL + this.lang + '/' + comp + '.json';

    if (path) {
      langPath = path;
    }
    return this.baseHttp.get(langPath)
      .pipe(catchError(err => {
        const fallbackPath = this._jsonURL + 'en-US/' + comp + '.json';
        return this.baseHttp.get(fallbackPath).pipe(catchError(() => of({})));
      }));
  }

}
